import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { severitiesActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class Severities extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newSeverity, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Gravidades'}
          classes={classes}
          newResource={newSeverity}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'gravidades'}
        />

        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.severities.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(severitiesActions.openModal())
    },
    closeModal: () => {
      dispatch(severitiesActions.closeModal())
    },
    newSeverity: severity => {
      dispatch(severitiesActions.newFormSeverity(severity))
    },
    resetState: () => {
      dispatch(severitiesActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(Severities))



// WEBPACK FOOTER //
// ./src/containers/Severities/index.js